<!-- FikoIsikOrtamComponent - Dialog Core içinde render ediliyor -->
<div style="width:100%;min-width:360px;">
    <div style="padding: 5px;font-size: 0.75em;">

        <input class="fikoinput" type="text" #inputFikogram placeholder="İsmi" [ngModel]="nesne?.name"
            (ngModelChange)="nesne.name=inputFikogram.value;this.FikoYT.degisti.emit();">

        <textarea class="fikoinputAciklama" #inputFikogramAciklama placeholder="Açıklaması"
            [ngModel]="nesne?.userData.aciklama"
            (ngModelChange)="nesne.userData.aciklama=inputFikogramAciklama.value;this.FikoYT.degisti.emit();"></textarea>


        <div style="display: flex;align-items:center;">
            <div>
                <input type="color" [ngModel]="'#'+nesne?.color.getHexString()" (ngModelChange)="renkDegisti($event);"
                    style="width: 3em;padding:0px !important;" tabindex="-1">
            </div>
            <div style="flex:1">
                <input type="range" [min]="0.01" [max]="5" tabindex="0" [ngModel]="nesne?.intensity" [step]="0.01"
                    (ngModelChange)="nesne.intensity=$event;nesne.sahne.anaGosterim.ciz();"
                    style="margin-top: 0.5rem;flex:1;" />
            </div>
        </div>


        <div style="text-align: right;">
            <div class="ui animated mini button" tabindex="0" (click)="kapa()">
                <div class="visible content">Kapat</div>
                <div class="hidden content">
                    <i class="check icon"></i>
                </div>
            </div>
        </div>
    </div>
</div>